module.exports = __webpack_public_path__ + "img/jack_02.8f90fd0a.png";